module.exports = __webpack_public_path__ + "static/cad-designs22-acf0cfde62df39d1101b0f7955efcfe2.png";